export const BASE_URL="https://eventpulsebackend.onrender.com";
// export const BASE_URL="http://localhost:4000";